<template>
  <div class="data-type">
    <template v-for="(item,i) in dataTypeList">
      <div :key="i" class="data-type-item text-overflow" v-if="showLength ? i < showLength : true" @click="changeType(item,i)" :class="i==typeIndex?'data-type-but-click':'data-type-but'" :style="{borderRadius: i==0?'4px 0px 0px 4px':i == dataTypeList.length-1?'0px 4px 4px 0px':''}">
        {{item.label}}
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    dataTypeList: {
      type: Array,
    },
    showLength: {
      type: Number,
      default: 0,
    },
    pageLoading:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      typeIndex: 0,
    }
  },
  watch: {},
  mounted() {},
  methods: {
    changeType(value, index) {
      if(this.pageLoading){
        return
      }
      this.typeIndex = index
      this.$emit('click', this.typeIndex)
    },
  },
}
</script>
<style lang='less'>
.data-type {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.data-type-item {
  cursor: pointer;
  padding: 0 10px;
  width: 170px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  // box-shadow: 0px 0px 3px rgb(160 13 20 / 30%);
  opacity: 1;
  border: 1px solid rgb(208, 208, 208);
  margin: -1px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/h-data-classify.vue